import React, { useState, useMemo, useEffect } from "react";
import { Row, Col, Container, Card, CardBody, Button } from "reactstrap";
import { useNavigate, useParams } from "react-router-dom";

import { getRecords, saveRecords } from "../../../services/api.service.js";
import "react-toastify/dist/ReactToastify.css";
import { createPageData } from "./CityFile.js";
import { basicFormData } from "./CityFile.js";
import {
  formContentContainer,
  loaderOverlay,
} from "../../../Style/loaderOverly.js";
import { AvForm } from "availity-reactstrap-validation";
import { LoaderCreatePage } from "../../Loader/Loader.js";
const CityView = () => {
  const breadcrumbItems = [];
  const { id } = useParams();
  const navigate = useNavigate();

  const { payload, navigatePage, headerName, getEndpoint } = createPageData();

  const initialPayload = useMemo(() => payload, []);
  const [loadingData, setLoadingData] = useState(id ? true : false);
  const [formData, setFormData] = useState(basicFormData());
  const [customerSelect, setCustomerSelect] = useState("");
  const [fetchedData, setFetchedData] = useState(null);
  const [isCustomerModelOpen, setIsCustomerModelOpen] = useState(false);
  const [companyName, setCompanyName] = useState(false);

  useEffect(() => {
    if (id) {
      getEditData(id);
    }
  }, [id]);

  useEffect(() => {
    if (fetchedData) {
      let data = fetchedData;
      setFormData((prevState) => ({
        ...prevState,
        inputData: {
          ...prevState.inputData,
          ...data,
        },
      }));
    }
  }, [fetchedData]);

  const getEditData = async (id) => {
    console.log("initialPayload", initialPayload);

    try {
      let payload = {
        modelName: initialPayload?.modelName,
        relations: [
          {
            module: "state_masters",
            moduleAs: "state_masters",
          },
        ],
      };
      if (id) {
        payload.whereCondition = { id: id };
      }
      const responseData = await getRecords(payload, getEndpoint);

      if (responseData?.data && responseData.data.length > 0) {
        const data = responseData.data[0];
        setFetchedData(data);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoadingData(false);
    }
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Row>
            <Col xl="12">
              <Card>
                <CardBody>
                  <div style={formContentContainer}>
                    <AvForm className="needs-validation">
                      <div className="card mt-4">
                        <div className="card-header">
                          <h5>City Details</h5>
                          <Button
                            color="secondary"
                            className="waves-effect waves-light me-1 back-button"
                            onClick={() => navigate(navigatePage?.back)}
                          >
                            Back
                          </Button>
                        </div>
                        <div className="card-body">
                          <Row>
                            {/* First Section (Left Side) */}
                            <Col
                              md="6"
                              //   className="border-end border-secondary p-3"
                            >
                              <p>
                                <strong>State Name: </strong>
                                {formData?.inputData?.state_masters
                                  ?.state_name || "-"}
                              </p>
                              <p>
                                <strong>City Name: </strong>
                                {formData?.inputData?.city_name || "-"}
                              </p>
                              <p>
                                <strong>Status: </strong>
                                {formData?.inputData?.is_active == true
                                  ? "ACTIVE"
                                  : "IN-ACTIVE" || "-"}
                              </p>
                            </Col>

                            {/* Second Section (Right Side) */}
                            {/* <Col md="6" className="p-3">
                              <p>
                                <strong>Customer: </strong>
                                <span
                                  className="text-primary cursor-pointer"
                                  style={{ cursor: "pointer" }}
                                  onClick={() => setIsCustomerModelOpen(true)}
                                >
                                  {companyName || "-"}
                                </span>
                              </p>
                            </Col> */}
                          </Row>
                        </div>
                      </div>
                    </AvForm>

                    {/* Loader Overlay */}
                    {loadingData && (
                      <div style={loaderOverlay}>
                        <LoaderCreatePage />
                      </div>
                    )}
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default CityView;
